import AgentAPI from "agent-api";

export async function getAlgorithm() {
  const res = await AgentAPI.Crypto.GetAlgorithms();
  const algorithms = res.Algorithms;
  if (algorithms && algorithms.length > 0) {
    return algorithms[0];
  }
  console.error("no algorithms");
}

export async function getBuyEdalerServiceProviders() {
  const res = await AgentAPI.Wallet.GetServiceProvidersForBuyingEDaler();
  return res.Providers;
}
